import { useEffect, useRef, useState } from 'react';
import { AutoComplete, Collapse, DatePicker, Input, Pagination, Radio, Slider, Spin } from 'antd';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { getCarinfoByVin, getCarListing, getSalvageCarListing } from '../../utils/api';
import { useDebounce } from 'use-debounce';
import carModels from '../findCar/carModels.json'
import SalvageCarInfo from './SalvageCarInfo';
import MarketCarInfo from './MarketCarInfo';

const FilteredCar = ({ filter: bannerFilter, heading, pageType }) => {
  const isFirstRender = useRef(true);
  const location = useLocation();
  const [cars, setCars] = useState([]);
  const [query] = useSearchParams();
  const isUpdate = query.get("update");
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [compare, setCompare] = useState([]);
  const [formValues, setFormValues] = useState([]);
  const [filters, setFilters] = useState({
    make: '',
    model: '',
    city: "",
    trim: '',
    radius: 50,
    price_max: '',
    price_min: '0',
    mileage:"",
    year_max: `${new Date().getFullYear()}`,
    year_min: `${new Date().getFullYear() - 5}`,
  });
  const navigate = useNavigate();
  const [debouncedFilters] = useDebounce(filters, 500);
  const [carInfo, setCarInfo] = useState({});

  const navigateInNewWindow = (vin, photoUrls) => {
    const queryParams = new URLSearchParams({ photoUrls: JSON.stringify(photoUrls) }).toString();
    const url = `/product_page/${vin}?${queryParams}`;
    window.open(url, '_blank');
  };


  const handleVinSearch = (vin, setVin) => {
    const photoUrls = cars.filter((item) => item.vin === vin).map((item) => item.images[0] && JSON.parse(item.images[0])).flat();
    setLoading(true);
    getCarinfoByVin(vin)
      .then((res) => {
        setLoading(false);
        if (res?.data) {
          setCarInfo(res?.data);
          setVin("");
          navigateInNewWindow(vin, photoUrls);
        } else {
          setCarInfo(null);
        }
      })
      .catch(() => setLoading(false));
  }

  const clearCompare = () => {
    localStorage.setItem("compareCars", JSON.stringify([]));
    localStorage.setItem("compareSalvage", JSON.stringify([]));
    setCompare([]);
  }
  const handleSelection = () => {
    if (pageType === "MarketCars") {
      if (isUpdate) {
        navigate('/compareCars?update=true', {
          state: { CompareCars: compare, filters: filters, inputFormValues: formValues }
        })
      } else {
        navigate('/compareCars', {
          state: { CompareCars: compare, filters: filters, inputFormValues: formValues }
        })
      }
    } else {
      if (isUpdate) {
        navigate('/compareSalvage?update=true', {
          state: { CompareCars: compare, filters: filters, inputFormValues: formValues }
        })
      } else {
        navigate('/compareSalvage', {
          state: { CompareCars: compare, filters: filters, inputFormValues: formValues }
        })
      }
    }
  }

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (pageType === "MarketCars") {
      setLoading(true);
      getCarListing(filters, currentPage)
        .then((res) => {
          setLoading(false);
          if (res?.data) {
            setCars(res?.data?.records);
            setTotalCount(res?.data?.totalCount);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
    if (pageType === "SalvageCars") {
      setLoading(true);
      getSalvageCarListing(filters, currentPage)
        .then((res) => {
          setLoading(false);
          if (res?.data) {
            setCars(res?.data);
            setTotalCount(res?.data?.totalCount);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }

  }, [debouncedFilters.make,
  debouncedFilters.year_min,
  debouncedFilters.year_max,
  debouncedFilters.price_min,
  debouncedFilters.mileage,
  debouncedFilters.radius,
  debouncedFilters.price_max,
  debouncedFilters.model,
  debouncedFilters.city,
  debouncedFilters.trim])


  useEffect(() => {
    if (location?.state?.filterInput) {
      const { state: { filterInput: { make, model, trim, city } } } = location;
      setFilters({ ...filters, make: make ? make : "", model: model ? model : "", trim: trim ? trim : "", city: city ? city : "" });
      localStorage.setItem("filters", JSON.stringify({ ...filters, make: make ? make : "", model: model ? model : "", trim: trim ? trim : "", city: city ? city : "", radius: 50 }))
    }
    if (location?.state?.formInputValues) {
      setFormValues(location?.state?.formInputValues);
      localStorage.setItem("formValues", JSON.stringify(location?.state?.formInputValues))
    }
    if (pageType === "MarketCars") {
      let res = JSON.parse(localStorage.getItem("compareCars"))
      if (res?.length) {
        setCompare(res);
      }
    }
    if (pageType === "SalvageCars") {
      let filters = JSON.parse(localStorage.getItem("filters"))
      setFilters(filters);
      let inputValues = JSON.parse(localStorage.getItem("formValues"))
      setFormValues(inputValues);
      let res = JSON.parse(localStorage.getItem("compareSalvage"))
      if (res?.length) {
        setCompare(res);
      }
    }
  }, []);

  return (
    <Spin
      spinning={loading}
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 48,
            color: 'black',
          }}
          spin
        />
      }
    >
      <h1 className='text-center my-6 text-[24px]'>
        <b>
          {heading}
        </b>
      </h1>
      {compare.length > 0 && <div className='mt-[20px] flex justify-center'>
        <div className='border w-full mx-5 md:w-[55%] md:mx-0 bg-[#e5e7eb] px-4 py-2 flex justify-between' style={{ boxShadow: "1px 0px 3px 2px #e5e7eb" }}>
          <div>
            {compare.length === 4 ? <p>
              You've reached the 4 vehicle max. Remove a vehicle to add another.
            </p> : <p>
              You've added {compare.length} of 4 vehicles. {compare.length < 2 && "Please add one more vehicle to compare."}
            </p>}
            {compare.length >= 2 && <button className='underline cursor-pointer' onClick={handleSelection}> see your Selections</button>}
          </div>
          <div className='flex'>
            <CloseOutlined className='cursor-pointer' onClick={() => clearCompare()} />
          </div>
        </div>
      </div>}

      <div className={`${compare.length < 1 ? "pt-[25px]" : "pt-[22px]"} pb-[73px] mx-auto flex gap-3 max-w-[1120px] flex-col md:flex-row px-4 md:px-0 `}>
        <div className='md:w-[30%] w-full flex gap-2 flex-col'>
          <div >
            <Collapse
              size='large'
              items={[
                {
                  key: '1',
                  label: 'Search By VIN',
                  children: <SearchVin handleVinSearch={handleVinSearch} />,
                },
              ]}
              className='findCarCollapse'
              expandIconPosition='end'

            />
          </div>
          <div>
            <Collapse
              size='large'
              defaultActiveKey='1'
              items={[
                {
                  key: '1',
                  label: 'Apply Filters',
                  children: <Filter filters={filters} setFilters={setFilters} debouncedFilters={debouncedFilters} />,
                },
              ]}
              className='findCarCollapse'
              expandIconPosition='end'
            />
          </div>
        </div>
        {cars.length > 0 ? <>
          <div className='md:w-[70%] w-full grid sm:grid-cols-2 grid-cols-1 gap-x-4 gap-y-4 max-h-[1215px] overflow-x-hidden overflow-y-auto'>
            {cars?.map((carDetail) => {
              return pageType === "SalvageCars" ? <SalvageCarInfo carDetail={carDetail} key={carDetail?.id} compare={compare} setCompare={setCompare} setLoading={setLoading} pageType={pageType} /> : <MarketCarInfo carDetail={carDetail} key={carDetail?.id} compare={compare} setCompare={setCompare} setLoading={setLoading} pageType={pageType} />
            })}
          </div>
        </> : <div className='md:w-[70%] w-full flex justify-center items-center'>
          <p>No Data Found</p>
        </div>}
      </div>
    </Spin>
  );
};

export default FilteredCar;

export const Filter = ({ filters, setFilters, debouncedFilters }) => {
  const [modelOptions, setModelOptions] = useState([]);
  useEffect(() => {
    let res = carModels[debouncedFilters.make.split(" ").map((item) => item.charAt(0).toUpperCase() + item.slice(1)).join(" ")];
    if (res) {
      let filteredModels = res.map((item) => {
        return {
          label: item,
          value: item
        }
      })
      setModelOptions(filteredModels);
    } else {
      setModelOptions([])
    }
  }, [debouncedFilters.make])
  const handleChange = (value, name) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <div className='border-b p-5'>
        <div>
          <p className='font-light text-xs pt-4 pb-2'>Make</p>
          <Input
            onChange={(e) => handleChange(e.target.value, 'make')}
            value={filters.make}
          />
          <div>
            <p className='font-light text-xs pt-4 pb-2'>Model</p>
            <AutoComplete
              style={{
                width: "100%",
              }}
              onChange={(e) => handleChange(e, 'model')}
              value={filters.model}
              options={modelOptions}
            />
          </div>
          <div>
            <p className='font-light text-xs pt-4 pb-2'>Zip Code</p>
            <Input
              onChange={(e) => handleChange(e.target.value, 'city')}
              value={filters.city}
            />
          </div>
          <div>
            <p className='font-light text-xs pt-4 pb-2'>Trim</p>
            <Input
              onChange={(e) => handleChange(e.target.value, 'trim')}
              value={filters.trim}
            />
          </div>
          <div>
            <p className='font-light text-xs pt-4 pb-2'>Radius</p>
            <Slider min={0} max={1000} defaultValue={50} onChange={(e) => handleChange(e, 'radius')} value={filters.radius} />
          </div>
        </div>
      </div>

      <div className='border-b p-5'>
        <h2 className='font-semibold text-lg pb-4'>Price</h2>
        <div className='flex items-end'>
          <div>
            <p className='font-light text-xs pb-2'>Min</p>
            <Input
              onChange={(e) => handleChange(e.target.value, 'price_min')}
              type='number'
              value={filters?.price_min}
            />
          </div>
          <p className='px-4 font-light text-lg'>to</p>
          <div>
            <p className='font-light text-xs pb-2'>Max</p>
            <Input
              onChange={(e) => handleChange(e.target.value, 'price_max')}
              type='number'
              value={filters?.price_max}
            />
          </div>
        </div>
      </div>

      <div className='border-b p-5'>
        <h2 className='font-semibold text-lg pb-4'>Year</h2>
        <div className='flex items-end'>
          <div>
            <p className='font-light text-xs pb-2'>Min</p>
            <Input onChange={(e) => handleChange(e.target.value, 'year_min')}
              value={filters?.year_min} />
          </div>
          <p className='px-4 font-light text-lg'>to</p>
          <div>
            <p className='font-light text-xs pb-2'>Max</p>
            <Input
              onChange={(e) => handleChange(e.target.value, 'year_max')}
              value={filters?.year_max}
              type='number'
            />
          </div>
        </div>
      </div>
      <div className='border-b p-5'>
        <h2 className='font-semibold text-lg pb-4'>Mileage</h2>
        <div className='flex items-end'>
          <Input
            onChange={(e) => handleChange(e.target.value, 'mileage')}
            value={filters.mileage}
          />
        </div>
      </div>
    </>
  );
};

export const SearchVin = ({ handleVinSearch }) => {
  const [vin, setVin] = useState("");

  return (
    <>
      <div className='border-b p-5'>
        <div>
          <p className='font-light text-xs pt-4 pb-2'>VIN Number</p>
          <Input
            onChange={(e) => setVin(e.target.value)}
            value={vin}
          />
          <button
            className='bg-[#e5e7eb] text-black py-3 mb-2 w-full rounded-xl font-medium mt-6'
            onClick={() => handleVinSearch(vin, setVin)}
          >
            Search
          </button>
        </div>
      </div>
    </>
  );
};
